import isNil from 'lodash-es/isNil'

import { toFlatSelectItem } from '../../Flat'
import { toRequestSelectItem } from '../../Request'

import { APPOINTMENT_FORM_FIELD_NAME } from './AppointmentFormModal.constants'

export function getAppointmentFormAnchorHintKey({ requestIds, values }) {
  if (values[APPOINTMENT_FORM_FIELD_NAME.request]) {
    return 'Appointment.FormAnchorFromRequestKey'
  }

  if (!isNil(requestIds)) {
    return 'Appointment.FormManyRequestsHintKey'
  }

  return values[APPOINTMENT_FORM_FIELD_NAME.building] ||
    values[APPOINTMENT_FORM_FIELD_NAME.flat] ||
    values[APPOINTMENT_FORM_FIELD_NAME.resident]
    ? null
    : 'Appointment.FormNoAnchorHintKey'
}

export function getAppointmentFormRequestApiParams({ building, requestIds }) {
  if (!isNil(requestIds)) {
    return { request_ids: requestIds.join(',') }
  }

  return building ? { building: building.value } : null
}

export function toAppointmentFormBuildingItem(building) {
  return building
    ? { label: building.title || building.address?.value, value: building.id }
    : null
}

export function toAppointmentFormFlatItem(flat) {
  return flat ? toFlatSelectItem(flat) : null
}

// The request list sends request_no and the request profile requestNumber; the mock shows it as the backend will
export function toAppointmentFormRequestItem(item) {
  return {
    ...toRequestSelectItem(item),
    canEditDueDate: item.permissions?.can_edit_due_date,
    dueDate: item.due_date,
    number: item.request_no ?? item.requestNumber,
    title: item.title,
  }
}

export function toAppointmentFormRequestItems(items) {
  return items.map(toAppointmentFormRequestItem)
}
